import { createImmutableObjectClass } from 'immutable-less/ImmutableObject';
export const TimeZoneStrategyType = {
  PORTAL: 'PORTAL',
  ENROLLED_OBJECT: 'ENROLLED_OBJECT',
  STATIC_TIME_ZONE: 'STATIC_TIME_ZONE'
};
export default class TimeZoneStrategy extends createImmutableObjectClass({
  type: TimeZoneStrategyType.PORTAL,
  staticTimeZoneId: undefined
}) {
  setType(value) {
    return this.set('type', value);
  }
}